import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4e8bf4a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statusDetailsTabView" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = {
  key: 0,
  class: "rteWrapper"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "lastUpdated"
}
const _hoisted_7 = { key: 0 }

import { computed } from 'vue';
import { IconText } from '../../Molecules';
import { RteContentType } from '../../types';
import { markdownToHtml } from '../../helpers';
import { orderRteContentByUpdatedDesc } from '../../helpers/sortRteContentByUpdatedDesc';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusDetailsTabView',
  props: {
    rteContent: {}
  },
  setup(__props: any) {

const props = __props;

const sortedRteContent = computed(() => {
  if (!props.rteContent) {
    return [];
  }

  const newRteList = [...props.rteContent];
  newRteList.sort(orderRteContentByUpdatedDesc);
  return newRteList;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header"),
        _renderSlot(_ctx.$slots, "infoCard"),
        _renderSlot(_ctx.$slots, "emptyStateContainer"),
        (sortedRteContent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRteContent.value, (rte, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "rte"
                }, [
                  _createElementVNode("h4", null, _toDisplayString(rte.title), 1),
                  (_unref(markdownToHtml)(rte.htmlContent))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "content",
                        innerHTML: _unref(markdownToHtml)(rte.htmlContent)
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (rte.lastUpdated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_unref(IconText), {
                          text: 'Last updated: ' + rte.lastUpdated,
                          "icon-name": "clock",
                          "icon-md": true
                        }, null, 8, ["text"]),
                        (rte.nextReview)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("Next review")) + ": " + _toDisplayString(rte.nextReview), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "ctas")
      ])
    ])
  ]))
}
}

})